import { ReduxStore } from 'store/types';

function getAllEmptyMessage(state: ReduxStore): string {
  return state.user.getAll.config.emptyMessage;
}

export default getAllEmptyMessage;
